/* ABALLE first-party events — posts to the events.aballe.com collector.
   Lean, deferred, non-blocking. Page context comes from window.ABALLE_CTX
   (injected by snippets/aballe-events.liquid). Contract matches collector
   server.js: event_name required, dedup on event_id, ab_anon cookie is
   handled server-side. Privacy: email is SHA-256 hashed client-side before
   it ever leaves the browser (email_sha256), feeding Meta/Omnisend match
   quality without sending raw PII. */
(function () {
  'use strict';

  var ENDPOINT = 'https://events.aballe.com/collect';
  var CTX = window.ABALLE_CTX || {};
  var QS = new URLSearchParams(location.search);
  var ATTR_KEY = 'aballe_attribution_v1';
  var ATTR_MAX_AGE_MS = 1000 * 60 * 60 * 24 * 45;
  var ATTR_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'msclkid'];

  function uuid() {
    try { return crypto.randomUUID(); } catch (e) {}
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  function nowIso() { return new Date().toISOString(); }

  function readJson(key) {
    try {
      var raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function writeJson(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function clean(value, max) {
    if (value == null || value === '') return null;
    return String(value).slice(0, max || 300);
  }

  function lastParamValue(name) {
    var values = QS.getAll(name).filter(function (value) { return value != null && value !== ''; });
    return values.length ? values[values.length - 1] : null;
  }

  function queryValue(name) {
    return lastParamValue(name) || lastParamValue('ab_' + name) || null;
  }

  function currentTouch() {
    var out = {
      landing_page: location.pathname + location.search,
      referrer: document.referrer || null,
      touched_at: nowIso()
    };
    ATTR_PARAMS.forEach(function (name) {
      var value = queryValue(name);
      if (value) out[name] = clean(value, 300);
    });
    return out;
  }

  function hasCampaignSignal(touch) {
    return ATTR_PARAMS.some(function (name) { return !!touch[name]; });
  }

  function isExpired(attr) {
    var ts = Date.parse(attr && (attr.last_at || attr.first_at || ''));
    return ts && (Date.now() - ts > ATTR_MAX_AGE_MS);
  }

  function updateAttribution() {
    var touch = currentTouch();
    var stored = readJson(ATTR_KEY) || {};
    if (isExpired(stored)) stored = {};

    if (!stored.first_at) {
      stored.first_at = touch.touched_at;
      stored.first_landing_page = touch.landing_page;
      stored.first_referrer = touch.referrer;
      ATTR_PARAMS.forEach(function (name) {
        if (touch[name]) stored['first_' + name] = touch[name];
      });
    }

    if (hasCampaignSignal(touch)) {
      stored.last_at = touch.touched_at;
      stored.last_landing_page = touch.landing_page;
      stored.last_referrer = touch.referrer;
      ATTR_PARAMS.forEach(function (name) {
        if (touch[name]) stored['last_' + name] = touch[name];
      });
    } else if (!stored.last_at && stored.first_at) {
      stored.last_at = stored.first_at;
      stored.last_landing_page = stored.first_landing_page;
      stored.last_referrer = stored.first_referrer;
      ATTR_PARAMS.forEach(function (name) {
        if (stored['first_' + name]) stored['last_' + name] = stored['first_' + name];
      });
    }

    writeJson(ATTR_KEY, stored);
    return stored;
  }

  var ATTR = updateAttribution();

  function attributionValue(name) {
    return queryValue(name) || ATTR['last_' + name] || ATTR['first_' + name] || null;
  }

  function attributionProps(extra) {
    var p = {
      utm_source: attributionValue('utm_source'),
      utm_medium: attributionValue('utm_medium'),
      utm_campaign: attributionValue('utm_campaign'),
      utm_content: attributionValue('utm_content'),
      utm_term: attributionValue('utm_term'),
      fbclid: attributionValue('fbclid'),
      gclid: attributionValue('gclid'),
      msclkid: attributionValue('msclkid'),
      attribution_first_landing_page: ATTR.first_landing_page || null,
      attribution_last_landing_page: ATTR.last_landing_page || null,
      attribution_first_referrer: ATTR.first_referrer || null,
      attribution_last_referrer: ATTR.last_referrer || null,
      attribution_first_at: ATTR.first_at || null,
      attribution_last_at: ATTR.last_at || null
    };
    if (extra) { for (var k in extra) { if (extra[k] != null) p[k] = extra[k]; } }
    return p;
  }

  function safeTag(value) {
    value = String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
    return value ? value.slice(0, 80) : null;
  }

  function attributionTags(baseTags) {
    var p = attributionProps();
    var tags = (baseTags || []).slice();
    var source = safeTag(p.utm_source);
    var medium = safeTag(p.utm_medium);
    var campaign = safeTag(p.utm_campaign);
    var content = safeTag(p.utm_content);
    if (source) tags.push('source_' + source);
    if (medium) tags.push('medium_' + medium);
    if (campaign) tags.push('campaign_' + campaign);
    if (content) tags.push('content_' + content);

    var haystack = [
      p.utm_source, p.utm_medium, p.utm_campaign, p.utm_content,
      p.attribution_first_landing_page, p.attribution_last_landing_page,
      p.attribution_first_referrer, p.attribution_last_referrer
    ].join(' ');
    if (/saint/i.test(haystack)) tags.push('source_saint');
    if (/paid_social|facebook|meta/i.test([p.utm_source, p.utm_medium].join(' '))) tags.push('source_meta_paid');
    if (/horologium/i.test(haystack + ' ' + location.pathname)) tags.push('product_horologium');

    var seen = Object.create(null);
    return tags.filter(function (tag) {
      tag = String(tag || '').trim();
      if (!tag || seen[tag]) return false;
      seen[tag] = 1;
      return true;
    });
  }

  function decorateReturnTo(path) {
    var p = attributionProps();
    var url = new URL(path || '/', location.origin);
    url.searchParams.set('customer_posted', 'true');
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'].forEach(function (name) {
      if (p[name]) url.searchParams.set('ab_' + name, p[name]);
    });
    return url.pathname + url.search;
  }

  function identifyContact(email, baseTags, customProperties) {
    if (!email || !window.omnisend || typeof window.omnisend.identifyContact !== 'function') return false;
    var props = attributionProps(customProperties || {});
    window.omnisend.identifyContact({
      email: email,
      tags: attributionTags(baseTags),
      customProperties: props
    });
    return true;
  }

  window.AballeAttribution = {
    get: function () { return attributionProps(); },
    tags: attributionTags,
    tagString: function (baseTags) { return attributionTags(baseTags).join(','); },
    decorateReturnTo: decorateReturnTo,
    identifyContact: identifyContact
  };

  function base() {
    var attr = attributionProps();
    return {
      event_id: uuid(),
      event_time: new Date().toISOString(),
      page_path: location.pathname + location.search,
      referrer: document.referrer || null,
      utm_source: attr.utm_source,
      utm_medium: attr.utm_medium,
      utm_campaign: attr.utm_campaign,
      utm_content: attr.utm_content,
      utm_term: attr.utm_term,
      fbclid: attr.fbclid,
      attribution_first_landing_page: attr.attribution_first_landing_page,
      attribution_last_landing_page: attr.attribution_last_landing_page,
      attribution_first_referrer: attr.attribution_first_referrer,
      attribution_last_referrer: attr.attribution_last_referrer,
      product_id: CTX.product_id || null,
      variant_id: CTX.variant_id || null,
      product_family: CTX.product_family || null,
      collection: CTX.collection || null,
      currency: CTX.currency || null
    };
  }

  function send(name, props) {
    var p = base();
    p.event_name = name;
    if (props) { for (var k in props) { if (props[k] != null) p[k] = props[k]; } }
    try {
      fetch(ENDPOINT, {
        method: 'POST',
        credentials: 'include',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(p)
      }).catch(function () {});
    } catch (e) {}
  }
  // exposed so other scripts (popup, future appointment form) can emit:
  window.abTrack = send;

  // Lead-event dedupe: a given (event_name + email hash) fires at most once per
  // page load. Kills double-submits — e.g. the HOROLOGIUM form firing twice.
  var firedLeadKeys = Object.create(null);
  function sendLead(name, props) {
    var key = name + '|' + ((props && props.email_sha256) || '');
    if (firedLeadKeys[key]) return false;
    firedLeadKeys[key] = 1;
    send(name, props);
    return true;
  }
  window.abTrackLead = sendLead;

  // ---- js_error beacon ----
  // Capture uncaught errors + failed resource loads and beacon them to the
  // collector. This is ground truth for the Instagram in-app browser (now ~50%
  // of traffic), whose older WebView throws errors desktop Chrome does not.
  // Deduped + capped per page so it never floods. user_agent, page, and geo are
  // added server-side, and the whole payload lands in the collector's `raw`
  // jsonb — so we can see WHICH browser threw WHICH error on WHICH page.
  var firedErrSigs = Object.create(null);
  var errReported = 0;
  function reportError(message, source, line, col) {
    try {
      if (errReported >= 12) return;                  // cap per page load
      message = String(message == null ? '' : message).slice(0, 500);
      source = String(source == null ? '' : source).slice(0, 300);
      var sig = message + '|' + source + '|' + line;
      if (firedErrSigs[sig]) return;                  // one per distinct error
      firedErrSigs[sig] = 1;
      errReported++;
      send('js_error', {
        error_message: message,
        error_source: source,
        error_line: line != null ? String(line) : null,
        error_col: col != null ? String(col) : null
      });
    } catch (e) {}
  }
  window.addEventListener('error', function (e) {
    try {
      var t = e && e.target;
      if (t && t !== window && (t.src || t.href)) {   // resource load failure
        reportError('resource load failed: ' + (t.tagName || ''), t.src || t.href, null, null);
      } else if (e && (e.message || e.filename)) {     // uncaught JS error
        reportError(e.message, e.filename, e.lineno, e.colno);
      }
    } catch (x) {}
  }, true);
  window.addEventListener('unhandledrejection', function (e) {
    try {
      var r = e && e.reason;
      var m = (r && (r.message || ('' + r))) || 'unhandledrejection';
      var src = (r && r.stack) ? (String(r.stack).split('\n')[1] || '') : '';
      reportError('unhandledrejection: ' + m, src, null, null);
    } catch (x) {}
  });

  function sha256Hex(value) {
    if (!window.crypto || !crypto.subtle || !value) return Promise.resolve(null);
    var bytes = new TextEncoder().encode(String(value).trim().toLowerCase());
    return crypto.subtle.digest('SHA-256', bytes).then(function (buf) {
      return Array.prototype.map.call(new Uint8Array(buf), function (b) {
        return ('0' + b.toString(16)).slice(-2);
      }).join('');
    }).catch(function () { return null; });
  }
  // exposed so the popup can hash an email before firing its own lead event:
  window.abHash = sha256Hex;

  function on(selector, evt, fn) {
    document.addEventListener(evt, function (e) {
      var t = e.target && e.target.closest ? e.target.closest(selector) : null;
      if (t) fn(e, t);
    }, true);
  }

  function enhanceEmailPopupForm(form) {
    if (!form) return;
    var tagInput = form.querySelector('input[name="contact[tags]"]');
    var returnInput = form.querySelector('input[name="return_to"]');
    if (tagInput) tagInput.value = attributionTags(['newsletter', 'popup_signup']).join(',');
    if (returnInput) returnInput.value = decorateReturnTo('/?customer_posted=true');
    form.setAttribute('data-aballe-attribution-enhanced', 'true');
  }

  function enhanceEmailPopupForms(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('.email-popup-form')) enhanceEmailPopupForm(scope);
    var forms = scope.querySelectorAll ? scope.querySelectorAll('.email-popup-form') : [];
    Array.prototype.forEach.call(forms, enhanceEmailPopupForm);
  }

  enhanceEmailPopupForms(document);
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], enhanceEmailPopupForms);
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  // ---- page_view (carries product/collection context) ----
  send('page_view');

  // ---- add_to_cart ----
  on('form[action*="/cart/add"]', 'submit', function (e, form) {
    var idEl = form.querySelector('[name="id"]');
    send('add_to_cart', {
      variant_id: (idEl && idEl.value) || CTX.variant_id,
      value: CTX.price || null
    });
  });

  // ---- product_path_cta_clicked (hero routes, buy buttons, horologium CTA) ----
  on('.aballe-homepage__hero-route, .product-form__submit, #horologium-hero-cta, [data-ab-cta]',
    'click', function (e, t) {
      send('product_path_cta_clicked', {
        capture_surface: t.getAttribute('data-ab-cta') ||
          (t.id || (t.className && String(t.className).split(' ')[0]) || 'cta')
      });
    });

  // ---- size_guidance_opened (bracelet size/metal guide) ----
  on('details.aballe-bracelets-guide-toggle', 'toggle', function (e, t) {
    if (t.open) send('size_guidance_opened');
  });

  // ---- horologium_inquiry_submit (deduped — see sendLead) ----
  on('#horologium-form, #horologiumWaitlistForm', 'submit', function (e, form) {
    var emailEl = form.querySelector('input[type="email"], input[name*="email" i]');
    var fire = function (h) {
      sendLead('horologium_inquiry_submit', {
        product_family: 'horologium',
        lead_type: 'inquiry',
        capture_surface: form.id === 'horologiumWaitlistForm' ? 'horologium_waitlist_overlay' : 'horologium_product_form',
        email_sha256: h || null
      });
    };
    if (emailEl && emailEl.value) { sha256Hex(emailEl.value).then(fire); } else { fire(null); }
  });

  // ---- collector_email_capture (native newsletter / footer forms) ----
  // The popup tracks itself (data-aballe-track-manual) WITH the email hash before
  // it navigates. Native forms fire SYNCHRONOUSLY (no async hash) so the event
  // survives the page navigation instead of being lost to the unload.
  on('.email-popup-form', 'submit', function (e, form) {
    enhanceEmailPopupForm(form);
    var emailEl = form.querySelector('input[type="email"], input[name="contact[email]"], input[name*="email" i]');
    var email = emailEl && emailEl.value ? emailEl.value.trim() : '';
    if (!email || (emailEl && !emailEl.validity.valid)) return;
    try {
      sessionStorage.setItem('aballe_pending_capture_attribution', JSON.stringify(attributionProps()));
    } catch (x) {}
    identifyContact(email, ['newsletter', 'popup_signup'], {
      capture_surface: 'popup',
      form_context: 'collector_email'
    });
  });

  on('form', 'submit', function (e, form) {
    if (form.id === 'horologium-form' || form.id === 'horologiumWaitlistForm') return; // handled above
    if (form.getAttribute('data-aballe-track-manual') === 'true') return;   // popup self-tracks
    if (/\/cart\/add/.test(form.getAttribute('action') || '')) return;      // not a capture
    var emailEl = form.querySelector('input[type="email"], input[name="contact[email]"], input[name*="email" i]');
    if (!emailEl || !emailEl.value) return;                                 // only real email submits
    var surface = form.closest('footer') ? 'footer' : 'newsletter';
    sendLead('collector_email_capture', { capture_surface: surface, lead_type: 'email' });
  });
})();
